import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { QUALITY_POINTS } from "@/data/content";

const Quality = () => (
  <section id="quality" data-testid="quality-compliance-section" className="bg-cream py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Chapter
        index="05"
        eyebrow="Quality & Compliance"
        title="Exacting, and honest about it."
        description="We do not overclaim. What we inspect, we report; what we certify, we document. Here is precisely how your fabric is verified."
      />

      <div className="mt-14 grid gap-10 lg:grid-cols-[1.4fr_1fr]">
        <div className="grid gap-px bg-navy/10 sm:grid-cols-2">
          {QUALITY_POINTS.map((q, i) => (
            <Reveal key={q.title} delay={i * 0.07} className="h-full">
              <div className="h-full bg-cream p-7">
                <div className="gold-hairline mb-5 w-10" />
                <h3 className="font-serif text-lg font-medium text-navy sm:text-xl">{q.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{q.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="h-full">
          <div className="flex h-full flex-col justify-between border border-gold/40 bg-white p-9">
            <p className="font-serif text-2xl italic leading-snug text-navy">
              "If a lot does not meet the approved sample, it does not ship. That has been the rule
              since 1991 — and it is why buyers stay for decades."
            </p>
            <div className="mt-8">
              <div className="gold-hairline w-16" />
              <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.3em] text-royal">
                The house standard · Bhagalpur
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Quality;
